import { ConditionalExpr } from "@angular/compiler";
import { Input, Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from '@angular/common';

@Pipe({ name: "Object2keyvalue" })
export class ObjecttoKeyvalue implements PipeTransform {
  transform(Inputvalue: any): any {
    let newArray = [];
    Object.entries(Inputvalue).forEach(([key, value]) => {
      let newObj = {};
      newObj["key"] = key;
      newObj["value"] = value;
      newArray.push(newObj);
    });
    return newArray?.filter(item => item.key !== 'record_id');
  }
}

@Pipe({ name: "arrayChk" })
export class ArrayChk implements PipeTransform {
  transform(Inputvalue: any): any {
    if (Array.isArray(Inputvalue)) {
      return true;
    } else {
      return false;
    }
  }
}

@Pipe({ name: "arrayChkLength" })
export class ArrayChkLength implements PipeTransform {
  transform(Inputvalue: any): boolean {
    if (!Array.isArray(Inputvalue)) {
      return false;
    }
    if (Inputvalue.length === 0) {
      return false;
    }
    return Inputvalue.every(item =>
      typeof item === 'object' &&
      item !== null &&
      !Array.isArray(item)
    );
  }
}

@Pipe({ name: "arrayChkWithString" })
export class ArrayChkWithString implements PipeTransform {
  transform(Inputvalue: any): boolean {
    if (!Array.isArray(Inputvalue)) {
      return false;
    }
    if (Inputvalue.length === 0) {
      return false;
    }
    return Inputvalue.every(item =>
      typeof item === 'string' && typeof item !== 'object' && item !== null &&
      !Array.isArray(item)
    );
  }
}


@Pipe({ name: "objectChk" })
export class ObjectChk implements PipeTransform {
  transform(Inputvalue: any, ObjectInput: any): any {
    // console.log("Object", ObjectInput);
    // console.log("Inputs", Inputvalue);
    if (ObjectInput[Inputvalue] !== undefined) {
      return ObjectInput[Inputvalue];
    } else {
      return null;
    }
  }
}

@Pipe({ name: "tableChk" })
export class TableChk implements PipeTransform {
  transform(Inputvalue: any): any {
    if (typeof Inputvalue[0] === "object") {
      return true;
    } else {
      return false;
    }
  }
}

@Pipe({ name: "tableHeaders" })
export class TableHeaders implements PipeTransform {
  transform(Inputvalue: any): any {
    let newArray = [];
    Object.entries(Inputvalue[0]).forEach(([key, value]) => {
      newArray.push(key);
    });
    return newArray;
  }
}

@Pipe({ name: "orderbypipe" })
export class OrderByPipe implements PipeTransform {
  transform(value: any[], propertyName: string): any[] {
    if (propertyName)
      return value.sort((a: any, b: any) =>
        b[propertyName].localeCompare(a[propertyName])
      );
    else return value;
  }
}

@Pipe({ name: "tableBody" })
export class TableBody implements PipeTransform {
  transform(Inputvalue: any): any {
    let newArray = [];
    //   console.log('Inputvalue', Inputvalue);
    Inputvalue.forEach((element) => {
      let innerArray = [];
      //   console.log('element', element);
      Object.entries(element).forEach(([key, value]) => {
        innerArray.push(value);
        //   console.log('value', value);
      });
      newArray.push(innerArray);
    });
    // console.log('newArray1',newArray);
    return newArray;
  }
}

@Pipe({
  name: "customDate"
})
export class CustomDatePipe implements PipeTransform {
  transform(value: any, format: string = 'dd-MM-yyyy HH:mm:ss'): any {
    if (value) {
      const datePipe = new DatePipe('en-US');
      return datePipe.transform(value, format);
    }
    return '';
  }
}

@Pipe({
  name: 'stringCheck'
})
export class StringCheckPipe implements PipeTransform {
  transform(value: any): boolean {
    return typeof value === 'string';
  }
}
